import { render, staticRenderFns } from "./Presets.vue?vue&type=template&id=ddde0b28&scoped=true"
import script from "./Presets.vue?vue&type=script&lang=js"
export * from "./Presets.vue?vue&type=script&lang=js"
import style0 from "./Presets.vue?vue&type=style&index=0&id=ddde0b28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddde0b28",
  null
  
)

export default component.exports